<div class="pt-5 pb-4 position-relative">

</div>
<div class="container mt-5">
    <h3 class="text-center mb-4"  style="color: var(--warna-2)">Request to Book</h3>
    
    <hr class="mb-4">

    <div class="row" *ngIf="!bookingData">
      <div class="col-md-12 mb-5 mt-5 text-center">
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" width="1em" height="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 1a2 2 0 0 1 2 2v2H6V3a2 2 0 0 1 2-2zm3 4V3a3 3 0 1 0-6 0v2H3.36a1.5 1.5 0 0 0-1.483 1.277L.85 13.13A2.5 2.5 0 0 0 3.322 16h9.355a2.5 2.5 0 0 0 2.473-2.87l-1.028-6.853A1.5 1.5 0 0 0 12.64 5H11zm-1 1v1.5a.5.5 0 0 0 1 0V6h1.639a.5.5 0 0 1 .494.426l1.028 6.851A1.5 1.5 0 0 1 12.678 15H3.322a1.5 1.5 0 0 1-1.483-1.723l1.028-6.851A.5.5 0 0 1 3.36 6H5v1.5a.5.5 0 1 0 1 0V6h4z"></path></svg>
        <h4 class="mb-3">Bag's empty</h4>
        <small> Bag whispers: Fill me! </small>
      </div>
    </div>

    <div class="row" *ngIf="bookingData">
        <div class="col-md-7">
          <h4 class="mb-3"  style="color: var(--warna-2)">Booking Details</h4>
          <div class="mb-5">
            <p><strong>Date:</strong> {{ bookingData?.startDate || 'N/A' }}</p>
            <p><strong>Guests:</strong> {{ bookingData?.guests || 'N/A' }}</p>
      
            <p><strong>Accommodation:</strong> 
            {{ setAcc }}  
            </p>
          </div>

          <hr class="mb-4">


          <!-- Halaman Login Jika belum login//--------------------------------- -->
          <div *ngIf="!authService.isLoggedIn2()" class="alert alert-warning">
            <p>You’re not logged in yet. <a routerLink="/login-pelanggan" style="color:var(--warna-2)">Click here to log in</a> and continue your booking journey!</p>
          </div>


          <div *ngIf="authService.isLoggedIn2()" >

            <h4 class="mb-3" style="color: var(--warna-2)">Guest Details</h4>
            <form [formGroup]="pelangganForm" (ngSubmit)="reservasi()">
              <!-- Input Nama Lengkap -->
              <div class="mb-3">
        
                <label for="fullName" class="form-label">Full Name</label>
                <input 
                  type="text" 
                  class="form-control" 
                  id="fullName" 
                  formControlName="fullName" 
                  [ngClass]="{'is-invalid': submitted && pelangganForm.get('fullName')?.invalid}"
                 
                />
                <div class="text-danger" *ngIf="submitted && pelangganForm.get('fullName')?.invalid">
                  <div *ngIf="pelangganForm.get('fullName')?.hasError('required')">Please input your full name</div>
                </div>
              </div>
            
              <!-- Input Email -->
              <div class="mb-3">
                <label for="email" class="form-label">Email</label>
                <input 
                  type="email" 
                  class="form-control" 
                  id="email" 
                  formControlName="email" 
                  [ngClass]="{'is-invalid': submitted && pelangganForm.get('email')?.invalid}"
                />
                <div class="text-danger" *ngIf="submitted && pelangganForm.get('email')?.invalid">
                  <div *ngIf="pelangganForm.get('email')?.hasError('required')">Please input your email</div>
                  <div *ngIf="pelangganForm.get('email')?.hasError('email')">Email is invalid</div>
                </div>
              </div>
            
              <!-- Input Nomor Telepon -->
              <div class="mb-3">
                <label for="phone" class="form-label">Phone Number</label><br>
                <small class="form-text text-muted">
                  Your mobile number for booking updates (preferably a Whatsapp number)
                </small>
                <input 
                  #phoneInput
                  type="tel" 
                  class="form-control" 
                  id="phone" 
                  formControlName="phone" 
                  [ngClass]="{'is-invalid': submitted && pelangganForm.get('phone')?.invalid}"
                  placeholder="812345678"                       
                />
                <div class="text-danger" *ngIf="submitted && pelangganForm.get('phone')?.invalid">
                  <div *ngIf="pelangganForm.get('phone')?.hasError('required')">Please input your phone number</div>
                  <div *ngIf="pelangganForm.get('phone')?.hasError('pattern')">Please input a valid phone number</div>
                  <div *ngIf="pelangganForm.get('phone')?.hasError('alreadyExists')">This WhatsApp number is already registered</div>
                </div>
              </div>
            
              <!-- Input Catatan -->
              <div class="mb-3">
                <label for="notes" class="form-label">Notes to Host (Optional)</label>
                <textarea 
                  class="form-control" 
                  id="notes" 
                  formControlName="notes" 
                  rows="3"
                ></textarea>
              </div>

         <h5 class="mb-3">Payment Method</h5>
          <div class="mb-3">
            <!-- Radio Buttons -->
            <div class="form-check form-check-inline" *ngFor="let method of ['transfer', 'credit card']">
              <input
                class="form-check-input"
                type="radio"
                [value]="method"
                formControlName="paymentMethod"
                [id]="'payment_' + method"
                (change)="onPaymentMethodChange()" 
              />
              <label class="form-check-label" [for]="'payment_' + method">
                {{ method | titlecase }}
              </label>
            </div>

            <div class="text-danger" *ngIf="submitted && pelangganForm.get('paymentMethod')?.invalid">
              Please select a payment method.
            </div>
          </div>

          <!-- Conditional Select Box for Bank -->
     <div class="mb-3" *ngIf="pelangganForm.get('paymentMethod')?.value === 'transfer'">
        <label for="bankSelection">Select Bank</label>
        <select class="form-select" id="bankSelection" formControlName="bankName">
          <option value="" disabled selected>-- Choose Bank --</option>
          <option *ngFor="let bank of filteredBankList" [value]="bank.value">
            {{ bank.display }}
          </option>
        </select>

        <div class="text-danger" *ngIf="submitted && pelangganForm.get('bankName')?.invalid">
          Please select a bank.
        </div>
      </div>


            
              <hr>
              <div class="mb-3">
                <button type="submit" class="btn btn-primary">Reserve</button>
              </div>
            
            </form>
            

        </div>


          <!-- //--------------------------------- -->


        </div>
    
        <div class="col-md-5">
          <div class="card">
            <img [src]="getImageUrl(bookingData?.gambar_kapal['gambar'])"
                 class="card-img-top" 
                 alt="Boat Image" />
            <div class="card-body">
            
              <h5>
                {{ bookingData?.duration }} 
                <span *ngIf="!isArray(bookingData?.destination)">
                  {{ bookingData?.destination }}
                </span>
                <span *ngIf="isArray(bookingData?.destination)">
                  <span *ngFor="let dest of bookingData?.destination; let i = index">
                    {{ dest.tuj }}<span *ngIf="i < bookingData?.destination.length - 1">, </span>
                  </span>
                </span>
                | {{ bookingData?.nama_kapal }}
              </h5>


              <p>{{ bookingData?.startDate || 'N/A' }} | {{ bookingData?.guests || 'N/A' }}</p>
        
              <!-- Row for Edit and Remove -->
              <div class="row g-1 mb-3 pb-3 d-flex">
                <div class="col-md-12">
                  <!-- Edit: Kembali ke halaman sebelumnya -->
                  <a style="color: var(--warna-2)" href="#" (click)="goBack($event)">
                    <strong>Edit</strong>
                  </a> 
                  | 
                  <!-- Remove: Hapus data dan refresh -->
                  <a style="color: var(--warna-2)" href="#" (click)="removeBookingData($event)">
                    <strong>Remove</strong>
                  </a>
                </div>
              </div>



              <div class="w-100 mb-3" *ngIf="bookingData?.accomodations">
                <hr>
                <div *ngFor="let room of bookingData?.accomodations" class="d-flex justify-content-between align-items-center">
                  <span>{{ room.name }}</span>
                  <span class="price">IDR {{ room.price | number }}</span>
                </div>

               <div *ngIf="isCreditCardSelected"  class="d-flex justify-content-between align-items-center">           
                  <small class="text-muted fst-italic">Includes 3% credit card fee</small>
                  <span class="price">IDR {{ creditCardFee | number }}</span>
               </div>
              </div>


              <div class="w-100 mb-3" *ngIf="bookingData?.trip_kategori=='Boat Charter'">
                <hr>
                  <div  class="d-flex justify-content-between align-items-center">
                      <span>Adventure</span>
                      <span class="price">
                         IDR {{ bookingData?.total | number }} /group of {{ guestsCount }}
                      </span>
                  </div>

                  <div *ngIf="isCreditCardSelected"  class="d-flex justify-content-between align-items-center">                
                      <small class="text-muted fst-italic">Includes 3% credit card fee</small>
                      <span class="price">IDR {{ creditCardFee | number }}</span>
                  </div>
              </div>

          
              <!-- Row for Total -->
              <div class="row border-top g-1 mb-3 pb-3 d-flex" *ngIf="bookingData">
                  <div class="col-md-6">
                    <span><strong>Total :</strong></span>
                  </div>
                  <div class="col-md-6 text-end">
                    <span><strong>{{ 'IDR ' + (finalTotal | number) }}</strong></span>
                  </div>
             
                </div>
            </div>
          </div>
        </div>
      </div>

</div>

<!-- Modal Konfirmasi -->
<div class="modal fade" id="confirmRemoveModal" tabindex="-1" aria-labelledby="confirmRemoveModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmRemoveModalLabel">Cart</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Remove from cart?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary" (click)="confirmRemoveBooking()">Yes</button>
      </div>
    </div>
  </div>
</div>



<!-- Modal Konfirmasi Reservasi -->
<div class="modal fade" id="confirmReservasiModal" tabindex="-1" aria-labelledby="confirmReservasiModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="confirmReservasiModalLabel">Confirm Reservation</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        Are you sure you want to confirm this reservation?
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary" (click)="submitReservation()">Yes</button>
      </div>
    </div>
  </div>
</div>

<!-- Toast Notifikasi -->
<div class="toast-container position-fixed bottom-0 end-0 p-3" style="z-index: 11;">
  <div id="reservationToast" class="toast align-items-center text-bg-success" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="d-flex">
      <div class="toast-body">
        Reservation request submitted successfully!
      </div>
      <button type="button" class="btn-close me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
  </div>
</div>